"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const InvestmentSearchIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "52",
  height: "39",
  viewBox: "0 0 52 39",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2.516 30.286c0-.685-.564-1.243-1.26-1.243C.565 29.043 0 29.6 0 30.286c0 .688.564 1.246 1.257 1.246.695 0 1.26-.558 1.26-1.246",
      fill: "#FFF",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2.58 18.322h27.55V13.21H2.58v5.112zm28.421 1.593H1.71c-.48 0-.87-.357-.87-.796v-6.705c0-.44.39-.797.87-.797H31c.48 0 .87.357.87.797v6.705c0 .439-.39.796-.87.796z",
      fill: "#4BAF5E",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M25.896 31.532H3.803c-.522 0-.943-.389-.943-.866 0-.478.421-.866.943-.866h21.15v-4.835H1.883v3.15c0 .478-.42.866-.94.866-.522 0-.943-.388-.943-.866V24.1c0-.479.421-.866.943-.866h24.953c.52 0 .943.387.943.866v6.566c0 .477-.423.866-.943.866M1.886 6.568h23.069V1.732H1.885v4.836zm24.01 1.73H.943C.423 8.298 0 7.91 0 7.432V.866C0 .389.423 0 .943 0h24.953c.52 0 .943.389.943.866v6.566c0 .479-.423.866-.943.866zM39.372 24.064c-.534 0-1.067.197-1.48.593l-2.018 1.942a2.1 2.1 0 00-.011 3.02l7.775 7.586C44.778 38.34 46.401 39 48.074 39c.965 0 1.918-.223 2.756-.642a2.102 2.102 0 00.539-3.383L40.866 24.673a2.124 2.124 0 00-1.494-.61m0 2.11l10.503 10.301a4.022 4.022 0 01-1.8.416c-1.075 0-2.16-.405-2.949-1.19l-7.772-7.586 2.018-1.942",
      fill: "#FFF",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M26.839 2.093c-7.62 0-13.82 6.133-13.82 13.673 0 7.539 6.2 13.673 13.82 13.673s13.82-6.134 13.82-13.673c0-7.54-6.2-13.673-13.82-13.673m0 29.439c-8.787 0-15.936-7.073-15.936-15.766S18.053 0 26.84 0s15.935 7.073 15.935 15.766-7.149 15.766-15.935 15.766",
      fill: "#FFF",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M38.55 14.936c-.393 0-.746-.245-.845-.61-.823-3.074-3.075-5.62-6.176-6.984-.434-.19-.618-.672-.412-1.074.206-.4.727-.572 1.16-.382 3.571 1.571 6.166 4.507 7.117 8.05.114.433-.17.869-.635.976a.903.903 0 01-.21.024",
      fill: "#FFF",
      className: "svg-fill-secondary"
    })]
  })]
});

InvestmentSearchIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(InvestmentSearchIcon);

exports.default = _default;